import React, { useEffect, useState } from 'react';
import { TableRow, TableCell, Link } from '@material-ui/core';

import PieceOfNewsForm from '../news/PieceOfNewsForm';
import CustomSnackbar from '../../user/shared/CustomSnackbar';
import ExpandableSectionWithTable from './components/ExpandableSectionWithTable';

import useAdminUserSession from '../../../hooks/useAdminUserSession';

import PrivateWealthTeamsService from '../services/PrivateWealthTeamsService';

const headCells = [
  { id: 'title', numeric: false, disablePadding: false, label: 'Title', sortable: true },
  { id: 'name', numeric: false, disablePadding: false, label: 'Publisher', sortable: true },
  { id: 'date', numeric: false, disablePadding: false, label: 'Written', sortable: true },
  { id: 'type', numeric: false, disablePadding: false, label: 'Type' },
  { id: 'sources', numeric: false, disablePadding: false, label: 'Sources' },
  { id: 'edit', numeric: false, disablePadding: false, label: '' },
  { id: 'delete', numeric: false, disablePadding: false, label: '' },
];

const PrivateWealthTeamNews = ({
  team,
  open,
  fetchNews,
  fetching,
  hasChanges,
  newsTypes,
  riaInvestorParent,
  ...props
}) => {
  const { session } = useAdminUserSession();

  const [openAddNewsForm, setOpenAddNewsForm] = useState(false)
  const [selectedPieceOfNewsId, setSelectedPieceOfNewsId] = useState(null);
  const [selectedTeam, setselectedTeam] = useState(team);
  const [news, setNews] = useState([]);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');

  useEffect(() => {
    setNews(props.news);
  }, [props.news]);

  const onNewPieceOfNews = () => {
    setselectedTeam(team);
    setSelectedPieceOfNewsId(undefined);
    setOpenAddNewsForm(true);
  };

  const onEditNews = (news_to_edit) => {
    setselectedTeam(team);
    setSelectedPieceOfNewsId(news_to_edit.id);
    setOpenAddNewsForm(true);
  };

  const onRemoveNews = (news_to_remove) => {
    if (window.confirm('Are you sure you want to remove this news from the team?')) {
      PrivateWealthTeamsService.updateNews(team.id, session, { ...news_to_remove, remove: true }).then(() => {
        setNews(news.filter(news_item => news_item.id !== news_to_remove.id));
        setSnackBarMessage('News removed successfully');
        setShowSnackBar(true);
      });
    }
  };

  const onCloseModalAfterAction = (newItem) => {
    setOpenAddNewsForm(false);
    fetchNews();
    setSnackBarMessage(newItem ? 'News created successfully' : 'News updated successfully');
    setShowSnackBar(true);
  };

  const RowRenderer = (row, _isSelected, _index, _handleCheck) => (
    <TableRow
      hover
      tabIndex={-1}
      key={row.id}
      style={{ cursor: 'pointer' }}
      onClick={(event) => (row.id)}
    >
      <TableCell>
        <Link href={row.source_url} target={'_blank'}>{row.title}</Link>
      </TableCell>
      <TableCell>
        {row.extra_data?.publisher?.name}
      </TableCell>
      <TableCell>
        {row.written_at}
      </TableCell>
      <TableCell>
        {row.extra_data?.news_type}
      </TableCell>
      <TableCell>
        {Array.isArray(row.sources) ? row.sources.join(', ') : (row.source || '')}
      </TableCell>
      <TableCell>
        <Link to='' onClick={() => onEditNews(row)}>Edit</Link>
      </TableCell>
      <TableCell>
        {row.team_ids.length === 1 && <Link to='' onClick={() => onRemoveNews(row)}>Delete</Link>}
      </TableCell>
    </TableRow>
  );

  return (
    <>
      <ExpandableSectionWithTable
        title='Related News'
        open={open}
        fetching={fetching}
        headCells={headCells}
        rows={news}
        RowRenderer={RowRenderer}
        onAddNew={onNewPieceOfNews}
        addButtonLabel='Add News'
      />
      {
        openAddNewsForm ?
          <PieceOfNewsForm
            adminUserSession={session}
            pieceOfNewsId={selectedPieceOfNewsId}
            newsTypes={newsTypes}
            onClose={() => setOpenAddNewsForm(false)}
            open={openAddNewsForm}
            afterCreatePieceOfNews={() => onCloseModalAfterAction(true)}
            onDataUpdate={() => onCloseModalAfterAction(false)}
            fixedTeam={selectedTeam}
            itemIndex={selectedPieceOfNewsId || 0}
            riaInvestorParent={riaInvestorParent}
          />
          : null
      }
      {
        showSnackBar &&
        <CustomSnackbar
          open={showSnackBar}
          closeHandler={() => setShowSnackBar(false)}
          message={snackBarMessage}
          options={{
            severity: 'success'
          }}
        />
      }
    </>
  );
};

export default PrivateWealthTeamNews;
